import { TableLastUpdatedSkeleton } from '@/shared/data-table/components/table-skeleton'

import { Skeleton } from '@/components/ui/skeleton'

export function IntegrationsListSkeleton() {
	return (
		<div className="flex flex-col gap-4">
			<div className="flex w-full items-center justify-end gap-3">
				<TableLastUpdatedSkeleton />
				<Skeleton className="h-9 w-36" />
			</div>

			{/* KPI strip */}
			<div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
				{Array.from({ length: 4 }).map((_, i) => (
					<Skeleton key={i} className="h-[104px] w-full" />
				))}
			</div>

			{/* Connected table */}
			<Skeleton className="h-[280px] w-full" />
		</div>
	)
}
